import React from 'react';
import { Grid, CardContent, CardMedia, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { SupportAgentRounded } from '@mui/icons-material';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

export default function FAQSupport() {
  /*
  height: 100vh; 
  min-height: 500px;
  overflow: auto;
  */
  return (
    <div style={{ width: '100%' }}>
      <Grid container direction="row" spacing={5}>
        <Grid item xs={12}>
          <Typography variant="body2" align="center" gutterBottom>
            <b>FAQ Document :</b>
          </Typography>        
          <iframe            
            src="https://membership.cmdfw.org/docs/FAQ_How to Register.pdf"
            width="100%"
            height="600px"
            title="FAQ Document"
            style={{ border: 'none', display: 'block', minHeight: '100vh', overflow: 'auto' }}
          />
        </Grid>
      </Grid>
    </div>
  );
}

